var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.25C3.2165 12.25 4 11.4665 4 10.5C4 9.5335 3.2165 8.75 2.25 8.75C1.2835 8.75 0.5 9.5335 0.5 10.5C0.5 11.4665 1.2835 12.25 2.25 12.25Z",
    fill: "#DEDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.355 8.75H9.145C8.23649 8.75 7.5 9.48649 7.5 10.395V10.605C7.5 11.5135 8.23649 12.25 9.145 12.25H30.355C31.2635 12.25 32 11.5135 32 10.605V10.395C32 9.48649 31.2635 8.75 30.355 8.75Z",
    fill: "#DEDEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.355 17.5H2.145C1.23649 17.5 0.5 18.2365 0.5 19.145V19.355C0.5 20.2635 1.23649 21 2.145 21H30.355C31.2635 21 32 20.2635 32 19.355V19.145C32 18.2365 31.2635 17.5 30.355 17.5Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.355 0H2.145C1.23649 0 0.5 0.736492 0.5 1.645V1.855C0.5 2.76351 1.23649 3.5 2.145 3.5H30.355C31.2635 3.5 32 2.76351 32 1.855V1.645C32 0.736492 31.2635 0 30.355 0Z",
    fill: "#DEDEDE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.d5bc378340d852681038e15b46b96245.svg";
export { ForwardRef as ReactComponent };